<template>
  <div>
    <!--
    <b-form-group
      label="Título"
      label-for="title"
    >
      <b-form-input
        id="title"
        v-model="title"
        @input="onInputChange"
      />
    </b-form-group>
    -->
    <b-form-group
      :label="$t('custom_forms.types.date')"
      label-for="date"
    >
      <b-form-input
        id="date"
        v-model="date"
        @input="onInputChange"
      />
    </b-form-group>
    <b-form-group
      :label="$t('custom_forms.types.central_time')"
      label-for="central_time"
    >
      <b-form-input
        id="central_time"
        v-model="centralTime"
        @input="onInputChange"
      />
    </b-form-group>
    <b-form-group
      :label="$t('custom_forms.types.local_time')"
      label-for="local_time"
    >
      <b-form-input
        id="local_time"
        v-model="localTime"
        @input="onInputChange"
      />
    </b-form-group>
    <b-form-group
      class="text-capitalize"
      :label="$t('custom_forms.content')"
      label-for="content"
    >
      <b-form-textarea
      id="content"
      v-model="mailContent"
      rows="3"
      max-rows="6"
      @input="onInputChange"
      ></b-form-textarea>
      <small class="form-text text-muted">
        {{ $t("custom_forms.types.placeholder") }}s:
        @FECHA,
        @HORA,
        @FECHA_HORA,
        @REFERENCIA,
        @SOEID,
        @NOMBRE,
        @PUESTO,
        @EMAIL,
        @SIRH,
        @SUC_NOMBRE,
        @SUC_ESTADO,
        @SUC_MUNICIPIO,
        @SUC_SUBREGION,
        @SUC_GEOREF
        {{ $t("custom_forms.placeholder_tooltip") }}
      </small>
    </b-form-group>
  </div>
</template>

<script>
import {onMounted, ref} from '@vue/composition-api';

export default {
  props: {
    data: {
      type: Object,
      default: () => ({ data: [] }),
    },
    config: Object,
  },
  setup(props, {emit, root}) {
    // const title = ref("")
    const mailContent = ref("")
    const date = ref("")
    const localTime = ref("")
    const centralTime = ref("")
    onMounted(async () => {
      // title.value = props.data?.data?.[0]?.title
      date.value = props.data?.data?.[0]?.date
      localTime.value = props.data?.data?.[0]?.localTime
      centralTime.value = props.data?.data?.[0]?.centralTime
      mailContent.value = props.data?.data?.[0]?.mailContent
    });

    function onInputChange() {
      const payload = {
        // title: title.value,
        date: date.value,
        localTime: localTime.value,
        centralTime: centralTime.value,
        mailContent: mailContent.value,
      }

      emit("update:data", {
        data: [{ ...payload }] ,
      });
    }

    return {
      // title,
      mailContent,
      date,
      localTime,
      centralTime,
      onInputChange
    };
  },
};
</script>


<style scoped lang="scss">
@import "@/assets/scss/variables/_variables.scss";

::v-deep {
  .dark-layout {
    .form-group label {
      color: $theme-dark-label-color;
    }

    .form-text {
      color: $theme-dark-text-muted-color !important;
    }

    .form-control {
      background-color: $theme-dark-input-bg;
      border-color: $theme-dark-input-border-color;
      color: $theme-dark-body-color;

      &::placeholder {
        color: $theme-dark-input-placeholder-color;
      }

      &:focus {
        background-color: $theme-dark-card-bg;
        border-color: var(--primary);
        color: $theme-dark-headings-color;
      }
    }
  }
}
</style>
